import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UsersService } from '../../core/users/users.service';
import { Router } from '@angular/router';
import { validateLowercase, validateMinLength, validateSpecialCharacter, validateUppercase, validatenumber } from '../../utils/utils';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent {
  public frmForget: FormGroup;
  showStep = 1;
  messageText:string = "";
  finalButtonText:string = "";
  passwordNoCoincidencia:boolean = false;
  hidePassword: boolean = true;
  hidePassword2: boolean = true;

  constructor(
    private _formBuilder: FormBuilder,
    public userService: UsersService,
    public router: Router
  ){
    this.frmForget = this._formBuilder.group({
      user: ["correo@prueba.com", [Validators.required,Validators.email]],
      password: ["", [Validators.required,Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&]).{4,}$'),Validators.minLength(8)]],
      confirmpassword: [null, [Validators.required]]      
    });

    this.frmForget.get('password')?.valueChanges.subscribe( r => {
      if(r != this.frmForget.get('confirmpassword')?.value){
        this.messageText = "Contraseñas no coinciden";
        this.finalButtonText = "";
        this.passwordNoCoincidencia = true;
      }else{
        this.resetFinalMessage();
        this.passwordNoCoincidencia = false;
      }
    });
    this.frmForget.get('confirmpassword')?.valueChanges.subscribe( r => {
      if(r != this.frmForget.get('password')?.value){
        this.messageText = "Contraseñas no coinciden";
        this.finalButtonText = "";
        this.passwordNoCoincidencia = true;
      }else{
        this.resetFinalMessage();
        this.passwordNoCoincidencia = false;
      }
    });

    
  }

  validateUser(){    
    if(this.frmForget.get("user")?.valid){
      this.showStep = 2; //router con params
      //this.finalButtonText = "CERRAR";
      //this.resetFinalMessage();
      //servicios de validar usuario
      // ERR Datos ingresados no válidos. Intente nuevamente”.
    }else{
      this.messageText = "Campos sin completar.";
      this.finalButtonText = "";
    }
  }

  validatePassword(){
    if(this.frmForget.get("password")?.valid){
      this.messageText = "Contraseña modificada correctamente.";
      this.finalButtonText = "CERRAR"; 
    }else{
      this.messageText = "Debes cumplir los requisitos para la nueva contraseña.";
      this.finalButtonText = "";
    }
  }

  cancel(){
    this.router.navigateByUrl("/");
  }

  resetFinalMessage(){
    this.messageText = "";
    this.finalButtonText = "";
  }

  validatenumber(): boolean {
    return validatenumber(this.frmForget.value.password);
  }

  validateLowercase(): boolean {
    return validateLowercase(this.frmForget.value.password);
  }

  validateUppercase(): boolean {
    return validateUppercase(this.frmForget.value.password);
  }

  validateSpecialCharacter(): boolean {
    return validateSpecialCharacter(this.frmForget.value.password);
  }

  validateMinLength(): boolean{
    let valuePass = this.frmForget.value.password == null ? "" : this.frmForget.value.password;
    return validateMinLength(valuePass);
  }
}
